<template>
    <v-container>
        <v-row>
            <v-col>
                <v-card class="mb-6">
                    <v-card-title class="text-uppercase justify-center">{{ metaData.header }}</v-card-title>
                    <v-card-actions class="justify-end">
                        <v-btn color="teal" class="white--text" @click="openAddPartnerDialog">
                            {{ $t('addPartner') }}
                        </v-btn>
                    </v-card-actions>
                </v-card>
                <partner-manufacturer-showcases-filters
                    @filter-change="filterChange"></partner-manufacturer-showcases-filters>
                <v-card class="mt-6">
                    <partner-manufacturer-showcases-table ref="table" :filters="filters" @load-error="onDataLoadError"
                        @update="openUpdateDialog"></partner-manufacturer-showcases-table>
                </v-card>
            </v-col>
        </v-row>
        <partner-manufacturer-showcase-dialog v-if="isDialogOpen" :is-open="isDialogOpen" :mode="dialogMode"
            :initial-showcase="showcaseToEdit" @close="closeDialog" @submitted="onFormSubmitted"
            @failed="onFormFailed"></partner-manufacturer-showcase-dialog>
        <v-snackbar v-model="snackOpen" :color="snackColor" top>
            {{ snackText }}
            <template v-slot:action="{ attrs }">
                <v-btn text icon v-bind="attrs" @click="resetSnack">
                    <v-icon color="grey">close</v-icon>
                </v-btn>
            </template>
        </v-snackbar>
        <load-overlay :overlay="overlay" :z-index="10"></load-overlay>
    </v-container>
</template>

<script>
import LoadOverlay from "../../../components/overlays/LoadOverlay";
import { PartnerManufacturerShowcasesTable } from "../../../components/data-tables";
import { PartnerManufacturerShowcasesFilters } from "../../../components/filters";
import { PartnerManufacturerShowcaseDialog } from "../../../components/modals";
import { MixinTableLoadSnack } from "../../../mixins";
import { PartnerManufacturerShowcasesService } from "../../../services";

export default {
    name: "ReviewPartnerManufacturerShowcases",
    components: {
        LoadOverlay,
        PartnerManufacturerShowcasesTable,
        PartnerManufacturerShowcasesFilters,
        PartnerManufacturerShowcaseDialog,
    },
    mixins: [MixinTableLoadSnack],
    data() {
        return {
            metaUrl: '/partner-manufacturer-showcases',
            overlay: false,
            filters: {},
            isDialogOpen: false,
            dialogMode: 'create',
            showcaseToEdit: null,
        }
    },
    methods: {
        filterChange(filters) {
            this.filters = filters;
        },
        openAddPartnerDialog() {
            this.dialogMode = 'create';
            this.showcaseToEdit = null;
            this.isDialogOpen = true;
        },
        closeDialog() {
            this.isDialogOpen = false;
            this.dialogMode = 'create';
            this.showcaseToEdit = null;
        },
        openUpdateDialog(id) {
            this.overlay = true;
            PartnerManufacturerShowcasesService.getDetails(id)
                .then(res => {
                    this.showcaseToEdit = res.data;
                    this.dialogMode = 'update';
                    this.isDialogOpen = true;
                })
                .catch(err => {
                    console.log(err);
                    this.setErrorSnack();
                    this.setSnackText(this.$t('showcaseDetailsError'));
                    this.openSnack();
                })
                .finally(() => {
                    this.overlay = false;
                });
        },
        onFormSubmitted() {
            const isCreate = this.dialogMode === 'create';

            this.closeDialog();
            this.setSuccessSnack();
            this.setSnackText(this.$t(isCreate ? 'partnerAddSuccess' : 'showcaseUpdateSuccess'));
            this.openSnack();
            this.$refs.table.setItems();
        },
        onFormFailed() {
            this.setErrorSnack();
            this.setSnackText(this.$t(this.dialogMode === 'create' ? 'partnerAddError' : 'showcaseUpdateError'));
            this.openSnack();
        },
    },
    created() {
        PartnerManufacturerShowcasesService.setAuth(this.$store.getters.token);
    },
}
</script>
